export default __webpack_public_path__ + "static/reinventing-space-420a0473bbc9e8c42147c6ee500c46b2.webp";